<div
  class="alert alert-danger"
  style="
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  "
  role="alert"
>
  <h4 class="alert-heading">Página no encontrada</h4>
  <p>Usted está intentando acceder a una URL no registrada.</p>
</div>
